import { BuyGuideVendorBuyOpportunityDocuments } from '../../../components/BuyGuide';

export function BuyGuideBuyOpportunityDocuments() {
  return <BuyGuideVendorBuyOpportunityDocuments />;
}
